import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  SsoAccountFacade,
  SsoAccountData,
  SessionStorageKey,
  SessionStorageState,
} from "common";
import { Router } from "@angular/router";

@UntilDestroy()
@Component({
    selector: "ifm-account-setup",
    templateUrl: "./account-setup.component.html",
    styleUrls: ["./account-setup.component.scss"],
    standalone: false
})
export class AccountSetupComponent implements OnInit {
  currentSsoAccount: SsoAccountData;
  continueEnabled = true;

  constructor(
    private ssoAccountFacade: SsoAccountFacade,
    private router: Router,
  ) { }

  ngOnInit() {
    this.initSsoAccount();
    SessionStorageState.set(SessionStorageKey.AccountSetupViewed, true);
  }

  continue() {
    this.continueEnabled = false;
    this.router
      .navigate(['account', 'setup', 'verify-identity'], { replaceUrl: true })
      .finally(() => {
        this.continueEnabled = true;
      });
  }

  private initSsoAccount() {
    return this.ssoAccountFacade
      .getCurrentSsoAccount$()
      .pipe(untilDestroyed(this))
      .subscribe((currentSsoAccount: SsoAccountData) => {
        this.currentSsoAccount = currentSsoAccount;
      });
  }
}
